module.exports = __webpack_public_path__ + "img/depth-of-field2.432ea953.png";